import * as Yup from 'yup';

export const isValidEmail = (email: string) => {
	const emailSchema = Yup.string().email('Invalid email format');

	try {
		emailSchema.validateSync(email.trim());
		return true;
	} catch {
		return false;
	}
};
